import React from "react";

export default function Leads({
  agents, campaigns, selectedAgent, setSelectedAgent, selectedCampaign, setSelectedCampaign,
  leadCreatedDate, setLeadCreatedDate, leadAccountOpenedDate, setLeadAccountOpenedDate,
  leadKycCompletedDate, setLeadKycCompletedDate, leadActivatedDate, setLeadActivatedDate,
  addLead, searchedLeads, handleFileUpload, downloadSampleCSV, inputClass,
  totalLeadsCount, accountsOpenedCount, kycCompletedCount, activatedCount,
  exportToCSV, exportToExcel
}) {
  const accountRate = totalLeadsCount > 0 ? ((accountsOpenedCount / totalLeadsCount) * 100).toFixed(0) : 0;
  const kycRate = accountsOpenedCount > 0 ? ((kycCompletedCount / accountsOpenedCount) * 100).toFixed(0) : 0;
  const finalActivationRate = kycCompletedCount > 0 ? ((activatedCount / kycCompletedCount) * 100).toFixed(0) : 0;

  return (
    <div className="space-y-6 animate-fade-in">
      <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200 flex items-center justify-between">
        <div>
          <h2 className="text-lg font-bold text-slate-800">Leads Data</h2>
          <p className="text-slate-500 text-sm">Upload bulk leads via CSV or enter manually</p>
        </div>
        <div className="text-right">
          <button onClick={() => document.getElementById("leads-upload").click()} className="bg-white border border-slate-300 hover:bg-slate-50 text-slate-800 px-4 py-2 rounded-lg text-sm font-semibold shadow-sm transition-all">
            📤 Upload Leads CSV
          </button>
          <input id="leads-upload" type="file" accept=".csv,.xlsx" onChange={(e) => handleFileUpload(e, "leads_master")} className="hidden" />
          <p onClick={() => downloadSampleCSV("leads_master")} className="text-blue-600 text-xs mt-2 cursor-pointer font-medium hover:underline">Download Template</p>
        </div>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <div className="bg-white p-4 rounded-xl shadow-sm border border-slate-200">
          <h3 className="text-slate-500 text-xs font-bold uppercase tracking-wider mb-1">Total Leads</h3>
          <p className="text-2xl font-bold text-slate-900">{totalLeadsCount}</p>
        </div>
        <div className="bg-white p-4 rounded-xl shadow-sm border border-slate-200">
          <h3 className="text-slate-500 text-xs font-bold uppercase tracking-wider mb-1">Accounts Opened</h3>
          <p className="text-2xl font-bold text-slate-900">{accountsOpenedCount}</p>
        </div>
        <div className="bg-white p-4 rounded-xl shadow-sm border border-slate-200">
          <h3 className="text-slate-500 text-xs font-bold uppercase tracking-wider mb-1">KYC Completed</h3>
          <p className="text-2xl font-bold text-slate-900">{kycCompletedCount}</p>
        </div>
        <div className="bg-emerald-50 p-4 rounded-xl shadow-sm border border-emerald-200">
          <h3 className="text-emerald-700 text-xs font-bold uppercase tracking-wider mb-1">Activated</h3>
          <p className="text-2xl font-bold text-emerald-600">{activatedCount}</p>
        </div>
      </div>

      <div className="flex flex-wrap items-center justify-between bg-white p-6 rounded-xl shadow-sm border border-slate-200">
        <div className="text-center"><p className="text-slate-500 text-xs uppercase font-bold tracking-wider mb-1">Total Leads</p><p className="text-2xl font-bold text-slate-800">{totalLeadsCount}</p></div>
        <span className="text-slate-300 font-bold text-2xl hidden md:block">→</span>
        <div className="text-center"><p className="text-slate-500 text-xs uppercase font-bold tracking-wider mb-1">Accounts</p><p className="text-2xl font-bold text-slate-800">{accountRate}%</p></div>
        <span className="text-slate-300 font-bold text-2xl hidden md:block">→</span>
        <div className="text-center"><p className="text-slate-500 text-xs uppercase font-bold tracking-wider mb-1">KYC</p><p className="text-2xl font-bold text-slate-800">{kycRate}%</p></div>
        <span className="text-slate-300 font-bold text-2xl hidden md:block">→</span>
        <div className="text-center"><p className="text-emerald-700 text-xs uppercase font-bold tracking-wider mb-1">Activated</p><p className="text-2xl font-bold text-emerald-600">{finalActivationRate}%</p></div>
      </div>

      <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200">
        <h2 className="text-lg font-bold text-slate-800 mb-4">Add Lead Manually</h2>
        <div className="grid md:grid-cols-3 gap-4 mb-4">
          <select value={selectedAgent} onChange={(e) => setSelectedAgent(e.target.value)} className={inputClass}>
            <option value="">Select Agent</option>
            {agents.map((a) => <option key={a.id} value={a.id}>{a.name}</option>)}
          </select>
          <select value={selectedCampaign} onChange={(e) => setSelectedCampaign(e.target.value)} className={inputClass}>
            <option value="">Select Campaign</option>
            {campaigns.map((c) => <option key={c.id} value={c.id}>{c.name}</option>)}
          </select>
          <input type="date" value={leadCreatedDate} onChange={(e) => setLeadCreatedDate(e.target.value)} className={inputClass} title="Created Date" />
          <input type="date" value={leadAccountOpenedDate} onChange={(e) => setLeadAccountOpenedDate(e.target.value)} className={inputClass} title="Account Opened Date" />
          <input type="date" value={leadKycCompletedDate} onChange={(e) => setLeadKycCompletedDate(e.target.value)} className={inputClass} title="KYC Completed Date" />
          <input type="date" value={leadActivatedDate} onChange={(e) => setLeadActivatedDate(e.target.value)} className={inputClass} title="Activated Date" />
        </div>
        <button onClick={addLead} className="bg-slate-900 hover:bg-slate-800 text-white px-6 py-2 rounded-lg text-sm font-semibold shadow-sm transition-all">Save Lead</button>
      </div>

      <div className="bg-white p-6 rounded-xl shadow-sm border border-slate-200">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-bold text-slate-800">📋 Leads Directory</h2>
          <div className="flex gap-2">
            <button onClick={() => exportToCSV(searchedLeads, "leads_directory")} className="text-xs bg-slate-100 hover:bg-slate-200 text-slate-600 px-2 py-1 rounded transition-colors">CSV</button>
            <button onClick={() => exportToExcel(searchedLeads, "leads_directory")} className="text-xs bg-slate-100 hover:bg-slate-200 text-slate-600 px-2 py-1 rounded transition-colors">Excel</button>
          </div>
        </div>
        <div className="overflow-x-auto">
          <table className="w-full text-left text-sm text-slate-600">
            <thead className="bg-slate-50 text-slate-800 border-b border-slate-200">
              <tr><th className="p-3">Created</th><th className="p-3">Account Opened</th><th className="p-3">KYC</th><th className="p-3">Activated</th></tr>
            </thead>
            <tbody>
              {searchedLeads.map(lead => (
                <tr key={lead.id} className="border-b border-slate-100 hover:bg-slate-50">
                  <td className="p-3">{lead.created_date || "-"}</td><td className="p-3">{lead.account_opened_date || "-"}</td><td className="p-3">{lead.kyc_completed_date || "-"}</td><td className="p-3">{lead.activated_date || "-"}</td>
                </tr>
              ))}
              {searchedLeads.length === 0 && (<tr><td colSpan="4" className="p-4 text-center text-slate-400">No leads found.</td></tr>)}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}